import { graphql } from "relay-runtime"

export const deAiSuggestionsQueryDef = graphql`
  query deEpisodeOfCareAiSuggestionsQuery($appointmentId: ID!) {
    suggestedEpisodeOfCareIcdDiagnoses: de_suggestedEpisodeOfCareIcdDiagnoses(appointmentId: $appointmentId) {
      diagnosisCode
      id
      text
    }
  }
`
